import { create } from 'zustand';
import { createJSONStorage, persist } from "zustand/middleware";

interface UserState {
  account: string | null;
  balance: string;
  token: string;
  referral: string | null;
  rewards: any[] | null;
  setUser: (data: Partial<UserState>) => void;
  reset: () => void;
}

export const useUserStore = create<UserState>()(
  persist(
    (set) => ({
      account: null,
      balance: "0",
      token: "0",
      referral: null,
      rewards: null,
      setUser: (data) => set((state) => ({ ...state, ...data })),
      reset: () => set({ account: null, balance: "0", token: '0', referral: null, rewards: null }),
    }), 
    {
      name: "user-store",
      storage: createJSONStorage(() => localStorage),
    }
  )
);
